import getCustomerDetailsRequestUrl from "./getCustomerDetailsRequestUrl";
import validateConfig from "../validateConfig";
let customerDetailsPromise = null;
const getCustomerDetails = async (params) => {
    const { asosWebRequest, authClient, config } = params;
    validateConfig(config);
    if (!customerDetailsPromise) {
        const url = getCustomerDetailsRequestUrl(params);
        customerDetailsPromise = asosWebRequest
            .get({
            url,
            headers: {
                Authorization: await authClient.getAuthHeader(),
            },
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            customerDetailsPromise = null;
            throw error;
        });
    }
    return customerDetailsPromise;
};
export default getCustomerDetails;
